export default __webpack_public_path__ + "static/media/news100.518e28ba.jpg";